import { render, staticRenderFns } from "./academic.vue?vue&type=template&id=5715a909&scoped=true"
import script from "./academic.vue?vue&type=script&lang=js"
export * from "./academic.vue?vue&type=script&lang=js"
import style0 from "./academic.vue?vue&type=style&index=0&id=5715a909&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5715a909",
  null
  
)

export default component.exports